import shape from "./shape";

export default {

  components: {
    shape,
  },


  props: {
    side: String,
    shape: String,
    text: String,
    displayBrain: Boolean,
  },


  computed: {

    classes() {
      const classes = [
        'brain--half',
      ];

      classes.push('brain--half--' + this.side);

      return classes;
    },

  },


  template: /* html */`
  <div :class="classes">

    <!-- Circle -->
    <div class="brain--circle--container">
      <div class="brain--circle">
        <div class="brain--icon">
          <shape v-if="shape" :shape="shape"></shape>
        </div>
      </div>
    </div>

    <!-- Text -->
    <div class="brain--text">{{ text }}</div>

  </div>
  `
}